import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const shopify = defineConnector({
  identifier: "shopify",
  name: "Shopify",
  tagLine: "E-commerce platform",
  keywords:
    "ecommerce myshopify online store storefront admin api orders products",
  logo,
  protocol: "http",
  tags: ["featured"],
  defaultUrlPattern: () => "https://[^/]*\\.myshopify\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-Shopify-Access-Token",
        value: app.secret.accessToken,
      },
    ]),
  steps: [
    {
      title: "Get your Shopify Admin API access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Shopify admin, go to **Settings → Apps and sales channels → Develop apps**. Create an app, configure Admin API scopes, and install it to get an access token.",
        },
      ],
    },
    {
      title: "Enter your store domain",
      items: [
        {
          kind: "hostname",
          label: "Store domain",
          placeholder: "your-store.myshopify.com",
          required: true,
          target: { kind: "configuration", field: "storeDomain" },
          helperText: "Your Shopify store's myshopify.com domain.",
        },
      ],
    },
    {
      title: "Copy and paste your access token",
      items: [
        {
          kind: "input",
          label: "Admin API access token",
          placeholder: "shpat_...",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ storeDomain }) =>
      `https://${storeDomain}/admin/api/2024-01/shop.json`,
  },
  publicEnvVars: ({ storeDomain }) => ({
    SHOPIFY_URL: storeDomain ? `https://${storeDomain}` : "",
  }),
});
